module.exports = __webpack_public_path__ + "assets/Deals-accent.9fb4ab64.svg";